export function gsapCrescendo() {
    this._targets[0].classList.add('btn--crescendo');
}
